/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// components
import Group from 'material/group/group';
import Logo from 'material/graphic/logo/logo';
import Link from 'material/ctas/link/link_container';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/structure/footer/footer_styles';



/* ========== ~~~~~~~~~~ STRUCTURE : FOOTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Footer = (props) => {
	return (
		<footer id={`footer`} className={`structure ${props.classes.footer}`}>
			<Group name={`info`}>
				<Link type={`external`} action={`${url.company}`}><Logo name={`insticator`} text={`Insticator`} /></Link>
				<p>Copyrights 2019©</p>
			</Group>
			<Group name={`links`} type={`nav`}>
				{/*<Link type={`external`} text={`Help Center`} action={`https://support.insticator.com/`} divider />*/}
				<Link type={`external`} text={`Terms and Conditions`} action={`${url.company}/terms-of-service`} />
			</Group>
		</footer>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Footer);
